import { Link } from "react-router";

export function NotFound() {
  return (
    <div className="grid gap-2 p-5">
      <p className="text-[14px] text-fg">Изображение не найдено</p>
      <Link to="/results" className="text-[12.5px] text-accent-text hover:underline">
        ← Все результаты
      </Link>
    </div>
  );
}
